import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class CreateOpenTicketPassSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '3137904db8b44ae59c45eae76caeacae';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateOpenTicketPass;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return CreateOpenTicketPassSideEffect.TYPE_ID;
  }

  static create(): CreateOpenTicketPassSideEffect {
    return new CreateOpenTicketPassSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): CreateOpenTicketPassSideEffect {
    return new CreateOpenTicketPassSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new CreateOpenTicketPassSideEffect() as this;
  }

  isSame(other: CreateOpenTicketPassSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.CreateOpenTicketPass);
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateOpenTicketPassSideEffect;
  }

  static assertType(order: DataModel): order is CreateOpenTicketPassSideEffect {
    return order instanceof CreateOpenTicketPassSideEffect;
  }
}

export class CreateOpenTicketPassSideEffectBuilder extends DataModelBuilder<CreateOpenTicketPassSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateOpenTicketPassSideEffect {
    return CreateOpenTicketPassSideEffect.fromMap(context, map);
  }
}
